import { Helper } from '../Helper';
export class RawEnumeratorForEachFuncHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getCallable({}));
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Enumerator.Next');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'PACK');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PICK');
                sb.emitHelper(node, sb.noPushValueOptions(innerOptions), sb.helpers.call);
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
            },
        }));
    }
}

//# sourceMappingURL=RawEnumeratorForEachFuncHelper.js.map
